import React from 'react';
import { Box, Button, Menu } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  getMenuButtonStyles,
  getMenuPaperStyles,
  getMenuItemStyles,
  expandIconStyles,
} from '../styles/NavBarStyles';
import { useAppTheme } from '../../../context/theme.context';

const NavMenu = ({
  menuId,
  label,
  children,
  anchorEl,
  onMenuToggle,
  onMenuLeave,
}) => {
  const { colors } = useAppTheme();
  const isOpen = Boolean(anchorEl);

  const handleClose = () => {
    // Remover el foco antes de cerrar el menú
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    onMenuLeave(menuId);
  };

  return (
    <Box sx={{ display: 'inline-block' }}>
      <Button
        color="inherit"
        onClick={(event) => onMenuToggle(menuId, event)}
        aria-expanded={isOpen}
        aria-owns={isOpen ? menuId : undefined}
        aria-haspopup="true"
        endIcon={<ExpandMoreIcon sx={expandIconStyles(isOpen)} />}
        sx={getMenuButtonStyles(isOpen)}
      >
        {label}
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        disableRestoreFocus
        disableAutoFocus
        disableEnforceFocus
        disableAutoFocusItem
        TransitionProps={{
          onExited: () => {
            // Asegurar que el menú esté completamente cerrado antes de limpiar
          }
        }}
        MenuListProps={{ 
          'aria-labelledby': menuId,
          onMouseLeave: handleClose,
        }}
        sx={{
          pointerEvents: 'none',
          '& .MuiPaper-root': {
            ...getMenuPaperStyles(colors),
            '& .MuiMenuItem-root': getMenuItemStyles(colors),
          },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        keepMounted={false}
      >
        {children}
      </Menu>
    </Box>
  );
};

export default NavMenu;
